import { Card, Suit, Rank } from '../../types/Card';

export const createDeck = (): Card[] => {
  const deck: Card[] = [];
  const suits = Object.values(Suit);
  const ranks = Object.values(Rank);

  suits.forEach(suit => {
    ranks.forEach(rank => {
      deck.push({
        suit,
        rank,
        id: `${suit}-${rank}`,
        isFaceUp: false
      });
    });
  });

  return deck;
};

export const shuffleDeck = (deck: Card[]): Card[] => {
  const shuffled = [...deck];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const dealCards = (deck: Card[], numPlayers: number): Card[][] => {
  const hands: Card[][] = Array(numPlayers).fill(null).map(() => []);
  let playerIndex = 0;

  while (deck.length > 0) {
    hands[playerIndex].push(deck.pop()!);
    playerIndex = (playerIndex + 1) % numPlayers;
  }

  return hands;
};

export const getCardValue = (card: Card): number => {
  const rankValues: { [key: string]: number } = {
    'A': 14,  // Ace is highest
    'K': 13,
    'Q': 12,
    'J': 11,
    '10': 10,
    '9': 9,
    '8': 8,
    '7': 7,
    '6': 6,
    '5': 5,
    '4': 4,
    '3': 3,
    '2': 2
  };
  
  return rankValues[card.rank] || 0;
};

export const findHighestCard = (cards: Card[], suit: Suit): Card | null => {
  const cardsOfSuit = cards.filter(card => card.suit === suit);
  if (cardsOfSuit.length === 0) return null;
  
  return cardsOfSuit.reduce((highest, current) => {
    return getCardValue(current) > getCardValue(highest) ? current : highest;
  });
};

export const canPlayCard = (card: Card, leadSuit: Suit | null, playerCards: Card[]): boolean => {
  if (!leadSuit) return true; // First card of the round
  
  // If player has cards of the lead suit, they must play one
  const hasLeadSuit = playerCards.some(c => c.suit === leadSuit);
  if (hasLeadSuit) {
    return card.suit === leadSuit;
  }
  
  // If player doesn't have lead suit, they can play any card
  return true;
};

